<template>
  <div class="wt2-continuous-pagination" @scroll.passive="onScroll">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    onNextPage: {
      type: Function,
      default: () => {},
    },
    sensitivity: {
      type: Number,
      require: false,
      default: 256,
    },
    shouldObserve: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    const options = {
      root: this.$el,
      rootMargin: '500px 0px 500px 0px',
    };
    if (this.shouldObserve) {
      const observer = new IntersectionObserver((entries) => {
        _.each(entries, (entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.remove('-invisible');
          } else {
            entry.target.classList.add('-invisible');
          }
        });
      }, options);
      this.$emit('mounted', { observer });
    } else {
      this.$emit('mounted');
    }
  },

  methods: {
    onScroll: _.throttle(
      function (e) {
        const el = e.target;
        const left = el.scrollHeight - el.clientHeight - el.scrollTop;

        if (left <= this.sensitivity) {
          this.$emit('fetch-more');
          this.onNextPage(e);
        }
      },
      10,
      { leading: true, trailing: true }
    ),
  },
};
</script>
